import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QPollNotificationsRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAsync(true);
  }

  GetCallName() {
    return "operations/opsutils";
  }

  SetParams(orgName, user) {
    var ui = Globals._wsMgr.GetUserInfo();
    var readMessages = ui.GetReadMessages();
    var markedReadIdList = readMessages ? readMessages : [];
    var readMessagesQueue = JSON.stringify({ messageIds: markedReadIdList });
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    this.AddParameter("data", readMessagesQueue);
  }

  DoTransactionComplete(response) {
    var nMgr = Globals._wsMgr.GetNotificationMgr();
    if (nMgr == null) return;
    var r = JSON.parse(response);
    var success = r["success"];
    if (!success) {
    }
    nMgr.LoadMessages(r["notifications"]);
    nMgr.UpdateUI();
    nMgr.QueueNextPoll();
  }

  DoTransactionFailed(response) {
    var nMgr = Globals._wsMgr.GetNotificationMgr();
    if (nMgr) nMgr.KillListener();
  }

  DoSessionEnded() {
    this.DoTransactionFailed();
  }
}
